<template>
	<div style="background-color: #fff;padding: 2%;min-height: 99vh;">
		<div>
			<div>
				<el-card>
					<div style="display: flex;align-items: center;">
						<div style="font-family: sans-serif;font-weight: 600;color: #515151 ;">电子面单账号</div>
						<div style="position: absolute;right: 6%;">
							<el-button @click="addAcountWindow=true" type="primary" round>添加电子面单</el-button>
						</div>
					</div>
				</el-card>
			</div>
			<el-row :gutter="12">
				<el-col :span="6" v-for="i in accountList"  :key="i.id">
					<el-card class="item">
						<div class="item-header">
							<div>
								<!-- <el-image style="width: 1.5rem;height: 1.5rem;border-radius: 50%;margin-right: 0.4rem;"
									:src="global.expressLogoUrl+i.cpCode+'.png'" fit="scale-down"></el-image> -->
								<el-avatar :src="global.expressLogoUrl+i.cpCode+'.png'" :size="33" style="margin-right: 0.3rem;"></el-avatar>	
								<span>{{i.cpName}}</span>
							</div>
							<div class="typeName">{{i.expressAccountTypeName}}</div>
						</div>
						<div class="item-content">
							<div>{{i.nickname}}</div>
							<div>余额：{{i.quota}}</div>
							<!-- <el-button type="text" size="mini">设置价格表</el-button> -->
						</div>
						<div class="item-foot">
							<el-popconfirm @confirm="deleteExpressAccount(i.id)" title="确定要删除此单号源吗？">
								<template #reference>
									<el-icon><Delete /></el-icon>
								</template>
							</el-popconfirm>
						</div>
					</el-card>
				</el-col>
			</el-row>

		</div>

		<div v-show="addAcountWindow">
			<div
				style="position: fixed;width: 100%;height: 100%;background-color: rgb(20 20 20);left: 0%;top: 0;opacity: 0.7;z-index: 6;">
			</div>
			<div
				style="position: absolute;background-color: #fff;z-index: 7;left:33%;border-radius: 4px;width: 25%;padding: 0 2vw 2vh 2vw;top: 30vh;">
				<div style="z-index: 111;display: flow-root;">
					<el-button @click="addAcountWindow=false" type="text" size="medium"
						style="font-size: 1.3rem;color: #8a8c91;z-index: 8;float: right;">
						<i class="el-icon-close"></i>
					</el-button>
				</div>
				<div style="position: relative;text-align: center;white-space:nowrap;">
					<el-form :model="addAcountForm" :rules="addAcountRules" ref="addAcountForm" label-width="20%"
						size="small">
						<el-form-item label="面单类型" prop="typeCode">
							<el-select v-model="addAcountForm.typeCode" placeholder="请选择电子面单类型" style="width: 100%;">
								<el-option v-for="i in typeCode" :label="i.label" :value="i.value" :key="i.value"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="快递公司" prop="cpCode">
							<el-select v-model="addAcountForm.cpCode" placeholder="请选择快递公司" style="width: 100%;">
								<el-option v-for="i in cpList" :label="i.label" :value="i.value" :key="i.value"></el-option>
							</el-select>
						</el-form-item>
						<div v-if="addAcountForm.typeCode=='WD'">
							<div v-if="addAcountForm.cpCode=='ZTO'">
								<el-form-item label="客户编码" prop="account">
									<el-input v-model="addAcountForm.account"
										placeholder="电子面单账号/客户编码（联系合作网点获取）"></el-input>
								</el-form-item>
								<el-form-item label="打单密钥" prop="password">
									<el-input v-model="addAcountForm.password"
										placeholder="打单密钥（客户管理系统中分享名片-客户扫码获取）"></el-input>
								</el-form-item>
							</div>
							<div v-if="addAcountForm.cpCode=='YTO'">
								<el-form-item label="客户编码" prop="account">
									<el-input v-model="addAcountForm.account"
										placeholder="圆通K码/客户编码（联系合作网点获取）"></el-input>
								</el-form-item>
								<el-form-item label="打印密钥" prop="password">
									<el-input v-model="addAcountForm.password"
										placeholder="打印密钥（网点管家-物料管理-客户密钥管理中查询）"></el-input>
								</el-form-item>
							</div>
							<div v-if="addAcountForm.cpCode=='JT'">
								<el-form-item label="客户编码" prop="account">
									<el-input v-model="addAcountForm.account"
										placeholder="客户编码|业务员编码（联系合作网点获取）"></el-input>
								</el-form-item>
								<el-form-item label="密码" prop="password">
									<el-input v-model="addAcountForm.password" placeholder="请输入客户编码对应密码"></el-input>
								</el-form-item>
							</div>
						</div>
					</el-form>
					<el-button type="primary" @click="addForm()" style="width: 30%;margin-top: 0.3rem;" round >保存</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				accountList: [],
				addAcountWindow: false,
				addAcountForm: {
					cpCode: "ZTO",
					orgName: "",
					typeCode: "WD",
					account: "",
					password: "",
				},
				addAcountRules: {
					cpCode: [{
						required: true,
						message: '请选择快递公司',
						trigger: 'blur'
					}],
					typeCode: [{
						required: true,
						message: '请选择电子面单类型',
						trigger: 'blur'
					}],
					account: [{
						required: true,
						min: 4,
						max: 20,
						message: '请输入正确的电子面单账号',
						trigger: 'change'
					}],
					password: [{
						required: true,
						min: 4,
						max: 20,
						message: '请输入正确的电子面单密钥',
						trigger: 'change'
					}],
				},
				cpList: [{
						label: '中通快递',
						value: 'ZTO'
					},
					{
						label: '圆通速递',
						value: 'YTO'
					},
					{
						label: '极兔速递',
						value: 'JT'
					}
				],
				typeCode: [{
					label: '网点电子面单',
					value: 'WD'
				}]
			}
		},
		methods: {
			addForm() {
				this.$refs['addAcountForm'].validate((valid) => {
					if (valid) {
						this.addExpressAccount(this.addAcountForm);
					} else {
						return false;
					}
				});
			},
			toCpName(cpCode) {
				var code = {
					"YTO": "圆通速递"
				}
				return code[cpCode]
			},
			addExpressAccount(form) {
				let data = {
					cpCode: form.cpCode,
					orgName: this.toCpName(form.cpCode) + '-' + String(form.account),
					account: form.account,
					password: form.password,
				}
				this.apiService.post({
						modules: "addExpressAccount",
						content: data
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.$message({
								message: '添加成功',
								type: 'success'
							});
							this.addAcountWindow = false;
							setTimeout(() => {
								location.reload();
							}, 1000)
						}
					})
			},
			expressAccountList() {
				this.apiService.post({
						modules: "getExpressAccountList",
						content: {}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.accountList = res.data.expressAccountList;
							if (this.accountList.length > 0) {
								window.localStorage.setItem("expressAccountList", JSON.stringify(this.accountList));
							}
						}
					})
			},
			deleteExpressAccount(expressAccountId) {
				this.apiService.post({
						modules: "deleteExpressAccount",
						content: {
							expressAccountId: expressAccountId
						}
					})
					.then((res) => {
						//成功
						if (res.status) {
							this.$message({
								message: '删除成功',
								type: 'success'
							});
							setTimeout(() => {
								location.reload();
							}, 400)
						}
					})
			}
		},
		created() {
			try {
				var expressAccountList = this.global.expressAccountList;
				if (expressAccountList) {
					this.accountList = expressAccountList;
				}
			} catch (e) {
				//TODO handle the exception
			}
			this.expressAccountList();
		}
	}
</script>

<style scoped>
	.item {
		position: relative;
		width: 18vw;
		padding: 0.1rem;
		margin-top: 1rem;
	}

	.item-header,
	.item-header div {
		display: flex;
		align-items: center;
	}

	.item-header .typeName {
		color: #bcbcbc;
		position: absolute;
		right: 0.9rem;
	}

	.item-content {
		margin-top: 0.5rem;
		text-align: center;
	}

	.item-content div {
		margin-top: 0.5rem;
		margin-bottom: 0.5rem;
	}

	.item-foot {
		position: relative;
		/* width: 90%;
		bottom: 17%; */
		top: 0;
	}
</style>